/**
 * @generated SignedSource<<c409f70598a02b85f27c1f56709ff6a3>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type AnnouncementReactions_chat_removeReaction_Mutation$variables = {
  id: string;
};
export type AnnouncementReactions_chat_removeReaction_Mutation$data = {
  readonly removeThreadReaction: {
    readonly conversation: {
      readonly id: string;
    };
    readonly deletedAt: ISO8601DateTimeString | null;
    readonly id: string;
    readonly senderId: string | null;
    readonly text: UnknownJSON;
  };
};
export type AnnouncementReactions_chat_removeReaction_Mutation = {
  response: AnnouncementReactions_chat_removeReaction_Mutation$data;
  variables: AnnouncementReactions_chat_removeReaction_Mutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
      }
    ],
    "concreteType": "Message",
    "kind": "LinkedField",
    "name": "removeThreadReaction",
    "plural": false,
    "selections": [
      (v1/*: any*/),
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "text",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "senderId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "deletedAt",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "Conversation",
        "kind": "LinkedField",
        "name": "conversation",
        "plural": false,
        "selections": [
          (v1/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "AnnouncementReactions_chat_removeReaction_Mutation",
    "selections": (v2/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "AnnouncementReactions_chat_removeReaction_Mutation",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "a5d02269fa39d2be0bcb8625b34611b4",
    "id": null,
    "metadata": {},
    "name": "AnnouncementReactions_chat_removeReaction_Mutation",
    "operationKind": "mutation",
    "text": "mutation AnnouncementReactions_chat_removeReaction_Mutation(\n  $id: String!\n) {\n  removeThreadReaction(id: $id) {\n    id\n    text\n    senderId\n    deletedAt\n    conversation {\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "2ef1fd8266fdd1f7814a69aeda7c7506";

export default node;
